import { useRef } from "react";

import { useUploadInvoicePdf } from "../../hooks/useInvoices";
import type { InvoiceRegisterItem } from "../../lib/invoices";

/**
 * Die Belegdatei nachreichen.
 *
 * „Externen Beleg erfassen" durfte lange keine Datei mitbringen — im Register
 * stehen deshalb Einträge, deren Papier woanders liegt. Ohne Datei ist der
 * Beleg weder ansehbar noch per Mail verschickbar, und genau das steht sonst
 * kommentarlos als „PDF: Noch nicht hinterlegt" in den Metadaten. Der Block
 * erscheint nur, solange nichts hinterlegt ist.
 */
export default function BelegDateiNachreichen({
  item, onUpdated,
}: { item: InvoiceRegisterItem; onUpdated: (item: InvoiceRegisterItem) => void }) {
  const upload = useUploadInvoicePdf();
  const feld = useRef<HTMLInputElement>(null);

  const waehlen = (liste: FileList | null) => {
    const datei = liste?.[0];
    if (!datei) return;
    upload.mutate({ id: item.id, datei }, {
      onSuccess: (aktualisiert) => onUpdated(aktualisiert),
      onSettled: () => { if (feld.current) feld.current.value = ""; },
    });
  };

  return (
    <section className="invoice-detail-section">
      <div className="invoice-section-head">
        <div><p className="invoice-kicker">Dokument</p><h3>Belegdatei nachreichen</h3></div>
      </div>
      <p className="invoice-hint">
        Zu diesem Beleg liegt keine Datei. Mit PDF (oder Foto) wird er hier sichtbar und
        lässt sich per Mail verschicken.
      </p>
      <input
        ref={feld}
        type="file"
        accept=".pdf,.jpg,.jpeg,.png"
        disabled={upload.isPending}
        onChange={(event) => waehlen(event.target.files)}
      />
      {upload.isPending && <p className="invoice-hint">Datei wird abgelegt …</p>}
      {upload.isError && (
        <p className="invoice-error">
          {upload.error instanceof Error ? upload.error.message : "Die Datei ließ sich nicht ablegen."}
        </p>
      )}
    </section>
  );
}
